import { render, staticRenderFns } from "./AccessToken.vue?vue&type=template&id=7f0290ce&scoped=true&"
import script from "./AccessToken.vue?vue&type=script&lang=js&"
export * from "./AccessToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0290ce",
  null
  
)

component.options.__file = "AccessToken.vue"
export default component.exports